import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { mappingCampaignStateToDTO } from 'utils/campaign/mappers';

import { resetCampaignInfo } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const SAVE_CAMPAIGN_URL = '/api/v1/campaigns';

export const saveCampaign = (dashboardRoute: string): AppThunkAction => {
    return (dispatch, getState) => {
        const { createBanner, createCampaign, profRoles } = getState();
        const stateForValidate = { ...createBanner, ...createCampaign, profRoles };

        const body = {
            ...mappingCampaignStateToDTO(stateForValidate),
        };

        return fetcher.put(SAVE_CAMPAIGN_URL, body).then(() => {
            dispatch(push(dashboardRoute));
            dispatch(resetCampaignInfo(null));
        });
    };
};
